import gql from 'graphql-tag';

import type { UserSettings } from 'src/data/user';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateUserSettingsArgs } from 'src/types/backend';

import { FRAGMENT_USER_SETTINGS } from './schema';

const MUTATION = gql`
  mutation UpdateExtensionSettings($extensionCustomerId: ID, $extensionWorkspaceId: ID) {
    updateUserSettings(
      extensionCustomerId: $extensionCustomerId
      extensionWorkspaceId: $extensionWorkspaceId
    ) {
      ...UserSettings
    }
  }
  ${FRAGMENT_USER_SETTINGS}
`;

type Variables = BackendMutationUpdateUserSettingsArgs;
type Result = UserSettings;

export const updateExtensionSettings = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
